export default "__VITE_ASSET__CT2_KnMv__"